<template>
  <FishScene cena="mar-aberto" :escurecimento="0.5" class="carta">
    <div class="carta__interior">
      <div class="carta__topo">
        <h1 class="carta__titulo banner-titulo">{{ $t('maps.title') }}</h1>
      </div>

      <!-- A carta em si mora em `shared/mapas/CartaNautica.vue` (D21): a MESMA página de papel
           abre como folha de dentro de Pescar (7.5c) — dois lugares, um componente. -->
      <CartaNautica />
    </div>
  </FishScene>
</template>

<script>
import { FishScene } from '@/shared/ui';
import CartaNautica from '@/shared/mapas/CartaNautica.vue';

export default {
  name: 'MapsPage',
  components: {
    FishScene,
    CartaNautica
  }
};
</script>

<style scoped>
.carta {
  min-height: 100vh;
}

.carta__interior {
  max-width: 980px;
  margin: 0 auto;
  /* Reserva a folha ativa do rodapé e a faixa com o nome — com 64px o fim da página ficava atrás
   * delas no telefone (mesmo defeito do Upgrade e do Inventário, 23/09). */
  padding: var(--e-5) var(--e-4) calc(var(--altura-barra) + var(--e-5));
}

/* O título no PERGAMINHO do Paper Pack (papel.css) — tinta sobre papel. */
.carta__topo {
  text-align: center;
  margin-bottom: var(--e-5);
}

.carta__titulo {
  font-family: var(--fonte-display);
  font-size: var(--f-5);
  line-height: var(--lh-curto);
  margin: 0;
}

@media (max-width: 599px) {
  .carta__titulo {
    font-size: var(--f-3);
  }
}
</style>
